import { render } from "./AboutUsSection.vue?vue&type=template&id=79651d3b&scoped=true"
import script from "./AboutUsSection.vue?vue&type=script&lang=js"
export * from "./AboutUsSection.vue?vue&type=script&lang=js"

import "./AboutUsSection.vue?vue&type=style&index=0&id=79651d3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79651d3b"]])

export default __exports__